module.exports = __webpack_public_path__ + "static/media/blog-post.2.3062a357.md";